<h2>{{name}}</h2>
<hr/>
<h5>{{desc}}</h5>
<p>This component is to be used when having a list with multi selection. It works using a JbListSelection object, and there are 2 use cases of the component:</p>
<ul>
  <li><b>With [id]</b>: A checkbox for every item on the list, to select/unselect it.</li>
  <li><b>Without [id]</b>: A checkbox to select/unselect all the items of the list (current page).</li>
</ul>

<h6>Check <a href="/jbListSelection"><b>jbListSelection</b></a> doc for a full example</h6>

<h5 class="mt-4">Parameters:</h5>
<div class="col-12"><pre>{{api}}</pre></div>


<div class="whiteBg row">
  <div class="col-6 marB15">
    <h5 class="marB25">On the list header:</h5>
    <div class="code-box pad10">
      <pre>{{instance1}}</pre>
    </div>
  </div>
  <div class="col-6 marB15">
    <h5 class="marB25">On every list row:</h5>
    <div class="code-box pad10">
      <pre>{{instance2}}</pre>
    </div>
  </div>

  <div class="col-12 padB10">
    <jb-switch [(ngModel)]="isCheckboxDisabled" jbLabel="Disable Title">
    </jb-switch>
  </div>
  <div class="col-6">
    <ul class="list-unstyled table-list">
      <li class="list-header">
        <jb-list-checkbox [selection]="sel" [jbDisabled]="isCheckboxDisabled"></jb-list-checkbox>
        <jb-list-header-col class="col-7"  colTitle="Username"></jb-list-header-col>
      </li>
    </ul>
  </div>
  <div class="col-6">
    <ul class="list-unstyled table-list">
      <li class="list-row">
        <jb-list-checkbox [selection]="sel" [id]="'999'"></jb-list-checkbox>
        <div class="col-5">Napoleon Bonaparte</div>
        <div class="col-6">napoleon.bonaparte@gmail.com</div>
        <div class="col-1 text-right"><jb-btn jbType="edit-icon"></jb-btn></div>
      </li>
      <li class="list-row">
        <jb-list-checkbox [selection]="sel" [id]="'998'"></jb-list-checkbox>
        <div class="col-5">Julius Caesar</div>
        <div class="col-6">julius.ceasar@gmail.com</div>
        <div class="col-1 text-right"><jb-btn jbType="edit-icon"></jb-btn></div>
      </li>
    </ul>
  </div>
</div>

<hr>



